import { render, staticRenderFns } from "./AnaliseMargem2SupervisorVendedor.vue?vue&type=template&id=1c4f00c4&scoped=true&"
import script from "./AnaliseMargem2SupervisorVendedor.vue?vue&type=script&lang=js&"
export * from "./AnaliseMargem2SupervisorVendedor.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseMargem2SupervisorVendedor.vue?vue&type=style&index=0&id=1c4f00c4&scoped=true&lang=css&"
import style1 from "./AnaliseMargem2SupervisorVendedor.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f00c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDialog,VIcon,VRow,VSpacer})
